import * as PIXI from 'pixi.js';
import {addCanvasBackground, addGameLogo, addSlotBoard} from "./createSlotBoard";
import {addControlPanel} from "../controlPanel";
import {handleKeyUp} from "./handleEvents";
import {pixiComponents} from "../index";
import {updateCanvasSize} from "../../App";
import "../notifications/sessionExpired/sessionExpired";
import {CANVAS} from "../constants/configs";
import {
    addBonusWinAmountBoard,
    addBuyFreeSpinsBoard,
    addTextWinFreeSpins,
    setBuyFreeBetBoardVisible
} from "../freeSpin";
import {addQuestionModalBuyFreeSpins} from "../freeSpin/questionModalBuyFreeSpins";

document.addEventListener('keyup', handleKeyUp);

export const createGame = async () => {
    pixiComponents.app = new PIXI.Application({
        width: CANVAS.width,
        height: CANVAS.height,
        resolution: window.devicePixelRatio*1.5 || 1,
    });

    document.getElementById("canvasContainer").appendChild(pixiComponents.app.view);
    addCanvasBackground();
    addSlotBoard();
    addBuyFreeSpinsBoard();
    addBonusWinAmountBoard();
    addGameLogo();
    addControlPanel();
    addTextWinFreeSpins();
    addQuestionModalBuyFreeSpins();
    updateCanvasSize();
}
